<template>
  <ValidationObserver ref="observer" slim>
    <b-form :novalidate="true">
      <h5 class="text-primary font-weight-bold pb-2">FON Finder</h5>
      <ValidationProvider
        name="FON Number"
        rules="required|numeric|min:7|notification_exists"
        v-slot="{ errors, classes }"
      >
        <b-form-group class="mb-0">
          <label for="fonNumber" class="sr-only">Enter FON Number</label>
          <b-input-group>
            <b-form-input
              id="fonNumber"
              name="fonNumber"
              v-model="fonNumber"
              placeholder="Enter FON Number"
              maxlength="7"
              :class="classes"
              :aria-describedby="$errorsIdString(errors, 'fonNumber')"
              v-on:keydown.enter.prevent="onSubmit"
            />
            <template v-slot:append>
              <b-button @click="onSubmit" aria-label="Go to notification">Go</b-button>
            </template>
          </b-input-group>
          <InputErrors
            :errors="errors"
            errorsIdPrefix="fonNumber"
            class="d-block invalid-feedback"
          />
        </b-form-group>
      </ValidationProvider>
    </b-form>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'GoToNotification',
  data() {
    return {
      fonNumber: null,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.observer.validate()
        .then((result) => {
          if (result) {
            this.$http.get(`/notification/${this.fonNumber}/getId`)
              .then((response) => {
                this.$router.push({
                  name: 'notification',
                  params: { id: response.data },
                });
              });
          }
        });
    },
  },
};
</script>
